'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from "./extendedCRUDMethods";

export default function ProductResource($resource) {
    'ngInject';
    return $resource('/api/products/:id', { id: '@id' }, extendedCRUDMethods);
}



// WEBPACK FOOTER //
// ./client/components/resources/product.resource.ts